/**
 * QualityGateBox — displays the 4 quality criteria for crew strategy
 */

interface QualityGateProps {
  qualityCheck: {
    behavioral: boolean;
    transferable: boolean;
    competencyLinked: boolean;
    crewOwned: boolean;
  };
  onToggle?: (key: 'behavioral' | 'transferable' | 'competencyLinked' | 'crewOwned') => void;
  readOnly?: boolean;
}

const CRITERIA: { key: keyof QualityGateProps['qualityCheck']; label: string }[] = [
  { key: 'behavioral', label: 'Behavioural' },
  { key: 'transferable', label: 'Transferable' },
  { key: 'competencyLinked', label: 'Competency-linked' },
  { key: 'crewOwned', label: 'Crew member ownership' },
];

export default function QualityGateBox({ qualityCheck, onToggle, readOnly }: QualityGateProps) {
  return (
    <div className="bg-white border border-steel/20 rounded-lg p-4">
      <h4 className="text-sm font-semibold text-[#1B3A5C] mb-3">Quality Gate</h4>
      <div className="grid grid-cols-2 gap-2">
        {CRITERIA.map(({ key, label }) => {
          const checked = qualityCheck[key];
          return (
            <button
              key={key}
              onClick={() => !readOnly && onToggle?.(key)}
              disabled={readOnly}
              className={`flex items-center gap-2 px-3 py-2 rounded text-sm border transition-colors ${
                checked
                  ? 'bg-green-50 border-green-300 text-green-700'
                  : 'bg-gray-50 border-gray-200 text-gray-400'
              } ${readOnly ? 'cursor-default' : 'cursor-pointer hover:border-green-400'}`}
            >
              <span className="text-base">{checked ? '\u2611' : '\u2610'}</span>
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
